import React from "react";
import { useQuery } from "@apollo/client";
import { connect } from "react-redux";
import ProductGrid from "../Product/ProductList/ProductGrid";
import Content from "../ACF/Content";
import { GET_PAGE_CONTENT, GET_PRODUCTS } from "../apollo";
import PageLoading from "./PageLoading/PageLoading";
import InstaFeed from "../Parts/InstaFeed";

const mapStateToProps = state => {
    return {
        mediaType: state.appSettings.mediaType
    }
}

const HomePage = (props) => {
    var state = {
        acfContent: [],
        products: []
    }

    var perPage = 2;
    if (props.mediaType === "desktop") {
        perPage = 3;
    }

    const { loading, error, data } = useQuery(GET_PAGE_CONTENT, {
        variables: {
            slug: "/"
        }
    });

    var products = [];
    const { loading: productsLoading, error: productsError, data: productsData } = useQuery(GET_PRODUCTS, {
        variables: {
            first: perPage
        }
    });

    if (error) {
        console.error(error);
        return null;
    } else if (productsError) {
        console.error(productsError);
    }

    if (loading) {
        return <PageLoading />;
    }

    if (!productsLoading && productsData) {
        products = productsData.products.nodes;
    }

    document.title = "Veronica Virta";

    return <div>
        <Content content={data.page.acfContent.pagecustom} />

        <div className="product-list">
            <ProductGrid products={products} placeholderCount={perPage} />
        </div>

        {/* <InstaFeed account="veronicavirta" numberOfMediaElements={4} /> */}
    </div>;
}

export default connect(mapStateToProps)(HomePage);